module.exports = __webpack_public_path__ + "files/dc775ee8839ff11f6008dde6b406d8b1.png";